import { JustificationMigrationCompeting } from '@/domain/justify/domain/justification-migration-competing.enum';
import DateFormat from '@/shared/utils/date-format';

export default class RequestExpirationContract {
  requestDate: string;

  customExpiration: Boolean;

  expireAllFromContractGroup: Boolean;

  justification: string;

  reasonsCancellation: string;

  readonly migrationToCompetingFirmId = JustificationMigrationCompeting.MIGRATION_TO_COMPETING_FIRM;

  features: String[] = [];

  exemptFine: Boolean;

  exemptFineApprover: string;

  exemptFineForValue: boolean;

  exemptFineValue: any;

  exemptContractualTerm: boolean;

  expirationObservation: string;

  churnResponsible: string;

  customDateExpiration: string;

  billLastInvoice: boolean | null;

  constructor(obj: any = {}) {
    this.requestDate = obj.expiresAt || '';
    this.customExpiration = obj.customExpiration || true;
    this.justification = obj.justification || null;
    this.reasonsCancellation = obj.reasonsCancellation || '';
    this.expireAllFromContractGroup = obj.expireAllFromContractGroup || false;
    this.features = obj.features || [];
    this.exemptFine = obj.exemptFine || false;
    this.exemptFineApprover = obj.exemptFineApprover || null;
    this.exemptFineForValue = obj.exemptFine || false;
    this.exemptFineValue = obj.exemptFineValue || 0;
    this.exemptContractualTerm = obj.exemptContractualTerm || false;
    this.expirationObservation = obj.expirationObservation || '';
    this.churnResponsible = obj.churnResponsible || '';
    this.customDateExpiration = obj.customDateExpiration || '';
    this.billLastInvoice = obj.billLastInvoice ?? null;
  }

  get requestDateFormat() {
    return DateFormat.timestampToLocal(this.requestDate);
  }

  set requestDateFormat(date: string) {
    this.requestDate = !date ? '' : DateFormat.localToTimestamp(date);
  }

  get requestCustomDateFormat() {
    return DateFormat.timestampToLocal(this.customDateExpiration);
  }

  set requestCustomDateFormat(date: string) {
    this.customDateExpiration = !date ? '' : DateFormat.localToTimestamp(date);
  }

  isMigrationToCompetingFirm(): Boolean {
    return this.justification === this.migrationToCompetingFirmId;
  }
}
